import React, { useEffect, useState } from "react";
import { parsedUser } from "../../utils/GetCurrentUser";
import API from "../../api/api";
import { Container, Modal, Row } from "react-bootstrap";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { cashClosingReport } from "./reports/cash-closing.report";
import { useTranslation } from "react-i18next";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
  Roboto: {
    normal:
      "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf",
    bold: "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf",
    italics:
      "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf",
    bolditalics:
      "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf",
  },
};

export const PrintCashClosing = (props) => {
  const { t } = useTranslation();
  const user = parsedUser();
  const [url, setUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const bindDataRemote = async (GUIDClosingHeader) => {
    setIsLoading(true);
    try {
      // if (!props.GUIDClosingHeader) {
      //   return;
      // }
      let query = `IdUser=${user.IdUser}&token=${user.Token}`;
      let queryData = {
        Data: `@GUIDClosingHeader='${GUIDClosingHeader}'`,
      };
      let request = await API.postAction(
        `api/CashierClosing/PrintClousure?${query}`,
        queryData
      );
      // console.log("🚀 ~ bindDataRemote ~ request:", request.data)
      // console.log(JSON.parse(request.data[0].JSONData))
      // console.log({header: JSON.parse(request.data[0].JSONData)[0].Record[0]})
      // console.log({details: JSON.parse(request.data[0].JSONData)[0].Data})
      // const closingHeader = JSON.parse(request.data[0].JSONData)[0].Record[0];
      const Data = await JSON.parse(request.data[0].JSONData);
      console.log("🚀 ~ bindDataRemote ~ Data:", Data)
      const closingHeader = Data[0].Record[0];
      const closingDetails = Data[0].AmountDetail;
      const TransactionTotal = Data[0].TransactionTotal;
      // console.log("🚀 ~ bindDataRemote ~ TransactionTotal:", TransactionTotal)
      if (!closingHeader) {
        return;
      }
      const docDefinition = cashClosingReport(closingHeader, closingDetails, TransactionTotal);
      const pdfDocGenerator = pdfMake.createPdf(docDefinition);
      pdfDocGenerator.getBlob((blob) => {
        // console.log("🚀 ~ pdfDocGenerator.getBlob ~ blob:", blob);
        setUrl(URL.createObjectURL(blob));
      });
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (props.GUIDClosingHeader) {
      bindDataRemote(props.GUIDClosingHeader);
    }
  }, [props.GUIDClosingHeader]);
  // console.log(records)
  return (
    <Modal
      show={props.show}
      onHide={props.toggle}
      backdrop="static"
      keyboard={false}
      size={"xl"}
    >
      <Modal.Header closeButton>
        <Modal.Title>{t("Print Cash Closing")}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Container fluid className="overflow-auto table-responsive">
          <Row>
            {url ? <iframe src={url} width="100%" height="550px"></iframe> : (
              <div
                className="text-center"
                style={{ width: "100%", height: "550px" }}
              >
                {isLoading ? (
                  <h4>{t("Loading")}...</h4>
                ) : (
                  <h4>{t("No records found")}</h4>
                )}
              </div>
            )}
          </Row>
        </Container>
      </Modal.Body>
    </Modal>
  );
};
